/**

// Check if debug mode is enabled (global)
const urlParams = new URLSearchParams(window.location.search);

 * Card Events - Phase 7 Migration
 * Обработка событий карточек документов
 */


/**
 * Card Events Manager
 * Управляет всеми событиями карточек
 */
class CardEventsManager {
    constructor() {
        this.boundEvents = new Set();
        this.cardClickHandlers = new Map();
        this.isInitialized = false;
        
        // CardEventsManager initialization logging only in debug mode
    }
    
    /**
     * Инициализация обработчиков событий
     */
    initialize() {
        if (this.isInitialized) {
            return;
        }
        
        try {
            this.bindCardEvents();
            this.bindNavigationEvents();
            this.bindDynamicEvents();
            
            this.isInitialized = true;
            
            // Events bound logging only in debug mode
            
        } catch (error) {
            if (debugMode === '1') {
                console.error('[CardEventsManager] Failed to bind events:', error);
            }
        }
    }
    
    /**
     * Привязка основных событий карточек
     */
    bindCardEvents() {
        if (this.boundEvents.has('cardClick')) {
            return;
        }
        
        // Делегированные события для карточек
        $(document).off('click.cardEvents', '.document-card')
                   .on('click.cardEvents', '.document-card', (event) => {
                       this.handleCardClick(event);
                   });
        
        // События для элементов внутри карточек
        $(document).off('click.cardEvents', '.card-nav-button')
                   .on('click.cardEvents', '.card-nav-button', (event) => {
                       this.handleTabNavigation(event);
                   });
        
        // События для версий документов
        $(document).off('click.cardEvents', '.card-versions-counter')
                   .on('click.cardEvents', '.card-versions-counter', (event) => {
                       this.handleVersionsClick(event);
                   });
        
        this.boundEvents.add('cardClick');
    }
    
    /**
     * Привязка событий навигации
     */
    bindNavigationEvents() {
        if (this.boundEvents.has('navigation')) {
            return;
        }
        
        $(document).off('keydown.cardEvents', '.document-card')
                   .on('keydown.cardEvents', '.document-card', (event) => {
                       this.handleCardNavigation(event);
                   });
        
        // Arrow key navigation between cards
        $(document).off('keydown.cardEvents', '.file-list-container')
                   .on('keydown.cardEvents', '.file-list-container', (event) => {
                       this.handleListNavigation(event);
                   });
        
        this.boundEvents.add('navigation');
    }
    
    /**
     * Привязка динамических событий
     */
    bindDynamicEvents() {
        if (this.boundEvents.has('dynamic')) {
            return;
        }
        
        // Современная замена DOMNodeInserted через MutationObserver
        if (this.cardObserver) {
            this.cardObserver.disconnect();
        }
        
        this.cardObserver = new MutationObserver((mutations) => {
            mutations.forEach((mutation) => {
                if (mutation.type === 'childList') {
                    mutation.addedNodes.forEach((node) => {
                        if (node.nodeType === Node.ELEMENT_NODE) {
                            const $element = $(node);
                            if ($element.hasClass('document-card')) {
                                // Создаем event-like объект для совместимости
                                this.handleCardInserted({ target: node });
                            }
                            // Проверяем вложенные карточки
                            $element.find('.document-card').each((index, card) => {
                                this.handleCardInserted({ target: card });
                            });
                        }
                    });
                }
            });
        });
        
        // Начинаем наблюдение за всем документом
        this.cardObserver.observe(document.body, {
            childList: true,
            subtree: true
                   });
        
        // События изменения размера для responsive карточек  
        $(window).off('resize.cardEvents')
                 .on('resize.cardEvents', () => {
                     this.handleResize();
                 });
        
        this.boundEvents.add('dynamic');
    }
    
    /**
     * Обработка клика по карточке
     * Мигрировано из main.js card click logic
     */
    handleCardClick(event) {
        const card = $(event.currentTarget);
        const cardId = card.attr('data-card-id') || card.attr('id');
        const target = $(event.target);
        
        if (window.HyperLog) {
            window.HyperLog.debug('[CardEventsManager] Card clicked:', {
                cardId,
                targetClass: target.attr('class'),
                targetTag: target.prop('tagName')
            });
        }
        
        // Не обрабатываем клики по интерактивным элементам
        if (target.is('a, button, input, select, textarea') || 
            target.closest('a, button, input, select, textarea').length > 0) {
            return;
        }
        
        // Обработка специфичных элементов карточки
        if (target.hasClass('card-extract') || target.closest('.card-extract').length > 0) {
            this.handleExtractClick(card, event);
        } else if (target.hasClass('card-summary') || target.closest('.card-summary').length > 0) {
            this.handleSummaryClick(card, event);
        } else {
            this.handleGeneralCardClick(card, event);
        }
        
        // Вызываем пользовательские обработчики
        const customHandler = this.cardClickHandlers.get(cardId);
        if (customHandler && typeof customHandler === 'function') {
            customHandler(card, event);
        }
    }
    
    /**
     * Обработка клика по извлечению (extract)
     */
    handleExtractClick(card, event) {
        const extract = card.find('.card-extract');
        
        // Разворачивание/сворачивание extract
        if (extract.hasClass('expanded')) {
            extract.removeClass('expanded');
        } else {
            extract.addClass('expanded');
        }
        
        event.stopPropagation();
    }
    
    /**
     * Обработка клика по резюме (summary)
     */
    handleSummaryClick(card, event) {
        const summary = card.find('.card-summary');
        
        // Показ/скрытие полного резюме
        if (summary.hasClass('collapsed')) {
            summary.removeClass('collapsed');
        } else {
            summary.addClass('collapsed');
        }
        
        event.stopPropagation();
    }
    
    /**
     * Общая обработка клика по карточке
     */
    handleGeneralCardClick(card, event) {
        // Базовая логика - например, выделение карточки
        $('.document-card.selected').removeClass('selected');
        card.addClass('selected');
        
        // Можно добавить дополнительную логику
    }
    
    /**
     * Обработка навигации по карточкам с клавиатуры
     */
    handleCardNavigation(event) {
        const card = $(event.currentTarget);
        
        switch (event.key) {
            case 'Enter':
            case ' ':
                event.preventDefault();
                this.handleCardClick(event);
                break;
                
            case 'ArrowUp':
                event.preventDefault();
                this.navigateToCard(card, 'up');
                break;
                
            case 'ArrowDown':
                event.preventDefault();
                this.navigateToCard(card, 'down');
                break;
                
            case 'ArrowLeft':
                event.preventDefault();
                this.navigateToCard(card, 'left');
                break;
                
            case 'ArrowRight':
                event.preventDefault();
                this.navigateToCard(card, 'right');
                break;
        }
    }
    
    /**
     * Навигация к соседней карточке
     */
    navigateToCard(currentCard, direction) {
        let targetCard;
        
        switch (direction) {
            case 'up':
                targetCard = currentCard.prev('.document-card');
                break;
            case 'down':
                targetCard = currentCard.next('.document-card');
                break;
            case 'left':
                // Логика для grid layout
                targetCard = this.findCardInDirection(currentCard, -1);
                break;
            case 'right':
                // Логика для grid layout
                targetCard = this.findCardInDirection(currentCard, 1);
                break;
        }
        
        if (targetCard && targetCard.length > 0) {
            targetCard.focus();
            targetCard.get(0).scrollIntoView({ 
                behavior: 'smooth', 
                block: 'nearest' 
            });
        }
    }
    
    /**
     * Поиск карточки в определенном направлении для grid layout
     */
    findCardInDirection(currentCard, offset) {
        const cards = $('.document-card:visible');
        const currentIndex = cards.index(currentCard);
        const targetIndex = currentIndex + offset;
        
        if (targetIndex >= 0 && targetIndex < cards.length) {
            return cards.eq(targetIndex);
        }
        
        return null;
    }
    
    /**
     * Обработка навигации по табам в карточке
     */
    handleTabNavigation(event) {
        const button = $(event.currentTarget);
        const target = button.attr('data-bs-target');
        
        if (target) {
            // Bootstrap tab switching logic
            button.tab('show');
        }
        
        event.stopPropagation();
    }
    
    /**
     * Обработка клика по счетчику версий
     */
    handleVersionsClick(event) {
        const counter = $(event.currentTarget);
        const card = counter.closest('.document-card');
        const versionsTab = card.find('#card-versions-tab');
        
        if (versionsTab.length > 0) {
            versionsTab.click();
        }
        
        event.stopPropagation();
    }
    
    /**
     * Обработка навигации по списку карточек
     */
    handleListNavigation(event) {
        if (event.key === 'ArrowUp' || event.key === 'ArrowDown') {
            const cards = $('.document-card:visible');
            const focused = $('.document-card:focus');
            
            if (focused.length === 0 && cards.length > 0) {
                cards.first().focus();
                event.preventDefault();
            }
        }
    }
    
    /**
     * Обработка вставки новой карточки в DOM
     */
    handleCardInserted(event) {
        const card = $(event.target);
        
        if (card.hasClass('document-card')) {
            // Инициализируем события для новой карточки
            this.initializeCardEvents(card);
        }
    }
    
    /**
     * Инициализация событий для конкретной карточки
     */
    initializeCardEvents(card) {
        // Делаем карточку focusable
        if (!card.attr('tabindex')) {
            card.attr('tabindex', '0');
        }
        
        // Добавляем ARIA атрибуты для accessibility
        if (!card.attr('role')) {
            card.attr('role', 'article');
        }
    }
    
    /**
     * Обработка изменения размера окна
     */
    handleResize() {
        // Логика для responsive карточек
        $('.document-card:visible').each((index, element) => {
            const card = $(element);
            this.adjustCardLayout(card);
        });
    }
    
    /**
     * Настройка layout карточки для текущего размера экрана
     */
    adjustCardLayout(card) {
        const windowWidth = $(window).width();
        
        if (windowWidth < 768) {
            // Mobile layout
            card.addClass('mobile-layout');
        } else {
            card.removeClass('mobile-layout');
        }
    }
    
    /**
     * Регистрация пользовательского обработчика клика для карточки
     */
    registerCardClickHandler(cardId, handler) {
        this.cardClickHandlers.set(cardId, handler);
    }
    
    /**
     * Отмена регистрации обработчика
     */
    unregisterCardClickHandler(cardId) {
        this.cardClickHandlers.delete(cardId);
    }
    
    /**
     * Получение статистики событий
     */
    getStats() {
        return {
            boundEvents: Array.from(this.boundEvents),
            customHandlers: this.cardClickHandlers.size,
            isInitialized: this.isInitialized
        };
    }

    /**
     * Очистка событий и observers
     */
    cleanup() {
        $(document).off('.cardEvents');
        $(window).off('.cardEvents');
        
        // Отключаем MutationObserver
        if (this.cardObserver) {
            this.cardObserver.disconnect();
            this.cardObserver = null;
        }
        
        this.boundEvents.clear();
        if (debugMode === '1') {
                console.log('[CardEvents] Cleanup completed');
            }
    }
}

// Создаем singleton instance
const cardEventsManager = new CardEventsManager();

// Global exports для backward compatibility
window.cardEventsManager = cardEventsManager;
window.bindCardEvents = cardEventsManager.bindCardEvents.bind(cardEventsManager);
window.handleCardClick = cardEventsManager.handleCardClick.bind(cardEventsManager);
window.handleCardNavigation = cardEventsManager.handleCardNavigation.bind(cardEventsManager);

// ES Module exports
export { cardEventsManager };
export const { 
    bindCardEvents, 
    handleCardClick, 
    handleCardNavigation 
} = cardEventsManager; 